import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import './LanguageSwitcher.css';

type LanguageSwitcherProps = {
  variant?: 'default' | 'white-bg';
};

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    // Change language in i18next first
    i18n.changeLanguage(lng);

    // Get current path segments
    const currentPath = location.pathname;
    const pathSegments = currentPath.split('/').filter(Boolean);

    // If the first segment is a language code, replace it
    if (['fr', 'ar'].includes(pathSegments[0])) {
      pathSegments[0] = lng;
    } else {
      // Should not happen with new routing, but safe fallback
      pathSegments.unshift(lng);
    }

    // Preserve query string when changing language
    const newPath = `/${pathSegments.join('/')}${location.search}`;
    navigate(newPath);
  };

  return (
    <div className={`language-switcher ${variant === 'white-bg' ? 'white-bg' : ''}`}>
      <button
        className={`lang-btn ${i18n.language === 'fr' ? 'active' : ''}`}
        onClick={() => changeLanguage('fr')}
        title="Français"
      >
        FR
      </button>
      <button
        className={`lang-btn ${i18n.language === 'ar' ? 'active' : ''}`}
        onClick={() => changeLanguage('ar')}
        title="العربية"
      >
        AR
      </button>
    </div>
  );
};

export default LanguageSwitcher;

